import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBDateField, DBRadioButton, DBTextArea, DBTextField } from '_components';
import styles from './PrevTher.module.css';
import { PatientCareCenterNoteNavAnchor } from '../../NavAnchor';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';

class PatientCareCenterNoteWpSubjectivePrevTher extends React.Component {

    handlePrevTherClick(selectedVal) {
        if (selectedVal === undefined || selectedVal === false) {
            this.props.clearFields(this.props.noteId, 'PTEVAL', 'EVNO', this.props.evno, ['EVSUBPREVSUCCESS', 'EVSUBPREVDCDATE', 'EVSUBPREVLOCATION', 'EVSUBPREVDESC']);
        }
    }

    render() {
        return (
            <PatientCareCenterNoteSection id='subj_prev_ther' name='Previous Therapy' level={5}>
            <PatientCareCenterNoteNavAnchor id='subj_prev_ther'>
                <div id='subj_prev_ther'>
                    <div className={styles.row}>
                        <label className={styles.col1_wide}>Previous therapy for same condition?</label>
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBPREVSAME'
                            className={styles.col2}
                            selectedValue={true}
                            label='Yes'
                            onClick={(selectedVal) => this.handlePrevTherClick(selectedVal)}
                        />
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            field='EVSUBPREVSAME'
                            className={styles.col3}
                            selectedValue={false}
                            label='No'
                            onClick={(selectedVal) => this.handlePrevTherClick(selectedVal)}
                        />
                    </div>
                    

                    {this.props.prevTher &&
                        <div>
                            <div className={styles.row}>
                                <label className={styles.col1_wide}>Was previous therapy successful?</label>
                                <DBRadioButton
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBPREVSUCCESS'
                                    className={styles.col2}
                                    selectedValue={true}
                                    label='Yes'
                                />
                                <DBRadioButton
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBPREVSUCCESS'
                                    className={styles.col3}
                                    selectedValue={false}
                                    label='No'
                                />
                            </div>

                            <div className={styles.row}>
                                <div className={styles.col1_top}>Discharge Date:</div>
                                <DBDateField
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    maxDate={new Date()}
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBPREVDCDATE'
                                />
                            </div>

                            <div className={styles.row}>
                                <div className={styles.col1_top}>Location:</div>
                                <DBTextField
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBPREVLOCATION'
                                    className={styles.textarea}
                                />
                            </div>

                            <div className={styles.row}>
                                <div className={styles.col1_top}>Description:</div>
                                <DBTextArea
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBPREVDESC'
                                    className={styles.textarea}
                                />
                            </div>
                        </div>
                    }

                </div>
            </PatientCareCenterNoteNavAnchor>
            </PatientCareCenterNoteSection>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);

    return {
        noteId: noteId,
        evno: evno,
        prevTher: state.entities.notes.PTEVAL[evno].EVSUBPREVSAME ? state.entities.notes.PTEVAL[evno].EVSUBPREVSAME : false
    };
}

const connectedPatientCareCenterNoteWpSubjectivePrevTher = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteWpSubjectivePrevTher);
export { connectedPatientCareCenterNoteWpSubjectivePrevTher as PatientCareCenterNoteWpSubjectivePrevTher };

